/** Converte ignorado/conflito da API (string "true"/"false" ou boolean) para boolean. */
export function parseFlagConciliacao(value) {
  if (value === true || value === 1) return true;
  if (value === false || value === 0 || value == null || value === "") return false;
  if (typeof value === "string") {
    const v = value.trim().toLowerCase();
    return v === "true" || v === "t" || v === "1" || v === "sim";
  }
  return Boolean(value);
}

export function normalizarConciliacaoItem(item, extras = {}) {
  return {
    ...item,
    ...extras,
    ignorado: parseFlagConciliacao(item.ignorado),
    conflito: parseFlagConciliacao(item.conflito),
  };
}
